import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoMovingTruck = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>MovingTruck</title>
    <path
      d="M22.336 22.321v-8.19c0-.632.511-1.144 1.143-1.144h3.579c.382 0 .739.191.95.51l2.136 3.203c.126.187.192.408.192.634v3.845c0 .63-.511 1.142-1.143 1.142H27.67"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
    <path
      d="M22.336 22.322v1a1 1 0 0 0 1-1h-1Zm-16.002 1a1 1 0 1 0 0-2v2ZM6.156 7.666l.01-1-.01 1Zm-.01 1 15.048.16.022-2-15.05-.16-.02 2Zm15.19.303v13.353h2V8.969h-2ZM6 21.179V8.809h-2v12.37h2Zm16.335.143H10.335v2h12v-2Zm-16.002 0h-.19v2h.19v-2Zm-2.333-.143c0 1.183.96 2.143 2.143 2.143v-2A.143.143 0 0 1 6 21.179h-2ZM21.194 8.826c.079 0 .142.065.142.143h2c0-1.175-.946-2.13-2.12-2.143l-.022 2ZM6.167 6.666A2.143 2.143 0 0 0 4 8.81h2c0-.08.065-.144.144-.143l.022-2Z"
      fill="currentColor"
    />
    <path
      d="M8.62 27.041a2.81 2.81 0 1 0 0-5.618 2.81 2.81 0 0 0 0 5.618ZM25.397 27.042a2.81 2.81 0 1 0 0-5.618 2.81 2.81 0 0 0 0 5.618Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoMovingTruck;
